export default "<div class=\"field-label\" i18n>{{label}}</div>\n<input type=\"text\" [formControl]=\"control\" />"